<template>
  <a
    class="main-item-wrapper d-flex flex-column position-relative"
    @click="goTo(link)"
    v-if="!mobile"
  >
    <div class="item_img">
      <img :src="image" />
      <div class="latest-tag" v-if="latestTag">
        <span class="latest-text">NEW</span>
      </div>
      <!-- open balik klu dorang nk balik lock item -->
      <!-- <div class="lock-wrapper" v-if="!authenticated">
        <svg
          width="40"
          height="41"
          viewBox="0 0 40 41"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect y="0.0419922" width="40" height="40" rx="20" fill="#D9E021" />
          <path
            d="M14 30.542C13.45 30.542 12.979 30.346 12.587 29.954C12.195 29.562 11.9993 29.0913 12 28.542V18.542C12 17.992 12.196 17.521 12.588 17.129C12.98 16.737 13.4507 16.5413 14 16.542H15V14.542C15 13.1587 15.4877 11.9793 16.463 11.004C17.4383 10.0287 18.6173 9.54133 20 9.54199C21.3833 9.54199 22.5627 10.0297 23.538 11.005C24.5133 11.9803 25.0007 13.1593 25 14.542V16.542H26C26.55 16.542 27.021 16.738 27.413 17.13C27.805 17.522 28.0007 17.9927 28 18.542V28.542C28 29.092 27.804 29.563 27.412 29.955C27.02 30.347 26.5493 30.5427 26 30.542H14ZM14 28.542H26V18.542H14V28.542ZM20 25.542C20.55 25.542 21.021 25.346 21.413 24.954C21.805 24.562 22.0007 24.0913 22 23.542C22 22.992 21.804 22.521 21.412 22.129C21.02 21.737 20.5493 21.5413 20 21.542C19.45 21.542 18.979 21.738 18.587 22.13C18.195 22.522 17.9993 22.9927 18 23.542C18 24.092 18.196 24.563 18.588 24.955C18.98 25.347 19.4507 25.5427 20 25.542ZM17 16.542H23V14.542C23 13.7087 22.7083 13.0003 22.125 12.417C21.5417 11.8337 20.8333 11.542 20 11.542C19.1667 11.542 18.4583 11.8337 17.875 12.417C17.2917 13.0003 17 13.7087 17 14.542V16.542Z"
            fill="black"
          />
        </svg>
      </div> -->
    </div>
    <div class="titleDiv" v-if="title">
      <p class="mb-0 title_text text-left mt-2">
        {{ truncateString(title, 30) }}
      </p>
    </div>

    <div class="overlay">
      <div class="w-100 d-flex flex-column justify-content-between">
        <div class="w-100 d-flex flex-column">
          <div v-if="title" class="mb-1">
            <p class="mb-0 title_text_overlay text-left">{{ title }}</p>
          </div>
          <div
            class="d-flex justify-content-start mb-1"
            v-if="classificationLabel"
          >
            <p class="classificationLabel mb-0">
              {{ classificationLabel }}
            </p>
          </div>
          <div class="d-flex justify-content-start" v-if="categoriesLabel">
            <p class="categoryLabel mb-0 long-title text-left">
              {{ categoriesLabel }}
            </p>
          </div>
        </div>

        <!-- open balik klu nk lock -->
        <!-- <div
          class="w-100 d-flex justify-content-start align-items-center flex-row mt-3"
          v-if="authenticated"
        > -->
        <div
          class="w-100 d-flex justify-content-start align-items-center flex-row mt-3"
        >
          <div class="icon cursor-pointer" @click="goTo(link)">
            <img src="../../../assets/rtmklik/main-play.svg" alt="play icon" />
          </div>
          <p class="d-none d-lg-block mb-0 label">
            Tonton Sekarang
          </p>
          <!-- <div class="icon cursor-pointer" @click="addToFavorite(itemID)">
            <img src="../../../assets/rtmklik/main-like.svg" alt="play icon" />
          </div>
          <div class="icon cursor-pointer">
            <img src="../../../assets/rtmklik/main-share.svg" alt="play icon" />
          </div> -->
        </div>
      </div>
    </div>
  </a>
  <router-link
    :to="link"
    class="main-item-wrapper d-flex flex-column cursor-pointer position-relative"
    v-else
  >
    <div class="item_img">
      <img v-bind:src="image" @error="imageLoadError($event)" />
      <div class="latest-tag" v-if="latestTag">
        <span class="latest-text">NEW</span>
      </div>
    </div>
    <div class="titleDiv" v-if="title">
      <p class="mb-0 title_text text-left mt-2">{{ title }}</p>
    </div>
  </router-link>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
export default {
  name: "eksklusiv-card-comp",
  props: [
    "image",
    "latestTag",
    "title",
    "description",
    "link",
    "category",
    "data",
    "itemID",
  ],
  data: function() {
    return {
      mobile: false,
      window: {
        width: 0,
      },
      overlayData: this.data,
      classificationLabel: "",
      categoriesLabel: "",
      firstEpisodeLabel: "",
      userId: localStorage.getItem("user_id"),
    };
  },
  methods: {
    imageLoadError(event) {
      event.target.src = noimage;
    },
    goTo(link) {
      this.$router.push(link);
    },

    truncateString(str, num) {
      if (str.length > num) {
        return str.slice(0, num) + "...";
      } else {
        return str;
      }
    },
    handleResizeforCard() {
      this.window.width = window.innerWidth;

      if (this.window.width >= 992) {
        this.mobile = false;
      } else {
        this.mobile = true;
      }
    },
    initData() {
      const classificationFirst =
        this.overlayData &&
        this.overlayData.classification &&
        this.overlayData.classification.title &&
        this.overlayData.classification.title.en_US;

      this.classificationLabel = classificationFirst ? classificationFirst : "";

      // getCategories
      const categoriesFirst =
        this.overlayData &&
        this.overlayData.categories[0] &&
        this.overlayData.categories[0].title &&
        this.overlayData.categories[0].title.en_US;

      this.categoriesLabel = categoriesFirst ? categoriesFirst : "";
    },
  },
  created() {
    window.addEventListener("resize", this.handleResizeforCard);
    this.handleResizeforCard();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResizeforCard);
  },
  mounted() {
    this.initData();
  },
  computed: {
    ...mapGetters({
      authenticated: "auth/authenticated",
    }),
  },
};
</script>

<style scoped>
.main-item-wrapper {
  z-index: 1;
  text-decoration: none;
  cursor: pointer;
}

.item_img {
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  padding-top: calc(349 / 270 * 100%);
  z-index: 1;
}
.item_img img {
  background: 100%;
  width: 100%;
  height: 100%;
  overflow: hidden;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  position: absolute;
  z-index: 2;
}
.main-item-wrapper .overlay {
  display: none;
}
.lock-wrapper {
  width: 40px;
  height: 40px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
}
@media only screen and (min-width: 992px) {
  .main-item-wrapper:hover .titleDiv .title_text {
    color: #d9e021;
  }
  .main-item-wrapper:hover {
    transform: scale(1.01);
  }
  .main-item-wrapper:hover .titleDiv {
    display: none;
  }
  .main-item-wrapper:hover .item_img {
    padding-top: calc(349 / 270 * 100%);
    border-radius: 8px 8px 0 0;
  }
  .main-item-wrapper:hover .overlay {
    display: block;
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 14;
    width: 100%;
  }
  .main-item-wrapper:hover .overlay {
    display: block;
    position: absolute;
    top: 99%;
    left: 0;
    z-index: 14;
    width: 100%;
  }
}
.label {
  color: #fff;
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-align: left;
}
.latest-tag {
  position: absolute;
  top: 6px;
  right: 6px;
  padding: 3px 5px;
  background: #d9e021;
  border-radius: 4px;
  display: flex;
  align-items: center;
  z-index: 11;
}
.latest-text {
  color: #292929;
  font-family: Inter;
  font-weight: bold;
  font-size: 11px;
  line-height: 1.14;
  text-align: left;
}
.tags-wrapper {
  width: 45px;
  padding: 2px 4px;
  height: 20px;
  position: absolute;
  right: 0;
  top: 8px;
  background-color: #f00;
  z-index: 4;
}
.tags-text {
  font-size: 12px;
  font-family: "HelveticaNeue-Bold";
  font-weight: bold;
  line-height: 1.25;
  text-align: left;
  color: #fff;
  z-index: 4;
}

.title_text {
  color: #fff;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.classificationLabel {
  color: #fff;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 130%;
}
.categoryLabel {
  color: #fff;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.icon {
  width: 28px;
  height: 28px;
  margin-right: 8px;
}
.icon img {
  width: unset !important;
  height: 100%;
  object-fit: cover;
}
.overlay {
  background: #171f26;
  padding: 14px 16px;
  border-radius: 0 0 8px 8px;
}
.title_text_overlay {
  color: #fff;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
@media only screen and (max-width: 992px) {
  .item_img {
    filter: saturate(100%);
  }
}
@media only screen and (max-width: 480px) {
}
</style>
<style>
@media only screen and (max-width: 480px) {
}
</style>
